module.exports = __webpack_public_path__ + "img/exp4.d88eb74c.png";